import React, { Component, useEffect } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import history from "lib/history";
import Session from "lib/session";
import IntlContainer from "./intl-container";
import { ThemeProvider } from '@getgo/chameleon-web-react-wrapper';
import '@getgo/chameleon-web/components/registerAll';
import { Box } from "@mui/material";
import useAnalytics from 'lib/use-analytics';

const AppContainer = ({ store, locale, authorized, accountKey }) => {
  const { initialize } = useAnalytics();

  /**
   * If there is a destination in storage then clear it out and route to it.
   * Does not use resolve-route because we are just handling user intent here
   */
  useEffect(() => {
    // Initialize Amplitude if user is authorized
    if (authorized && accountKey) {
      initialize(accountKey);
    }

    const target = Session.getOriginalTarget();
    if (target) {
      Session.removeOriginalTarget();
      history.push(target);
    }
    // Empty deps is intentional: this must run once on mount only.
    // `initialize` and the auth props are not stable references — adding them
    // would re-run on every render and re-initialize Amplitude repeatedly.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider>
      <Provider store={store}>
        <Box style={{ height: "100%" }}>
          <IntlContainer meLocale={locale} />
        </Box>
      </Provider>
    </ThemeProvider>
  );
};
AppContainer.propTypes = {
  store: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  authorized: PropTypes.bool.isRequired,
  accountKey: PropTypes.string,
};

export default AppContainer;
